<template>
    <div class="container">
        <div class="notification TQ_text_14px TQ_ver TQ_box_shadow2 TQ_border_white TQ_Animation_smallBigSmall"
             v-if="show"
             :style="co_style_o">
            {{num}}

        </div>
        <slot></slot>
    </div>
</template>

<script>
    import {gv_zIndex} from "../../scripts/S_GlobalVar";

    export default {


        name: "TqNotificationContainer",
        props:{
            num:{
                type: Number,
                default: 0
            },
            background:{
                type: String,
                default: '#D2222D'
            },
            color : {
                type: String,
                default: 'white'
            },
            show :{
                type: Boolean,
                default: true
            },
            p_top : {
                type: String,
                default: '-16px'
            },
            p_right : {
                type: String,
                default: '-12px'
            }
        },
        computed:{
            co_style_o(){
                return {
                    'background': this.background ,
                    'color'     : this.color,
                    'top'       : this.p_top,
                    'right'     : this.p_right,
                    'zIndex'    : gv_zIndex.tqNotificationContainer_notification
                }
            }
        },
        data(){
            return {
                gv_zIndex : gv_zIndex
            }
        },
    }
</script>

<style scoped lang="scss">

    .container {
        position: relative;
        text-align: center;
        display: inline-block;
    }

    .notification{
        position: absolute;
        border-radius: 50%;
        width: 18px;
        height: 18px;
        padding: 2px;
        font-family: Arial;
    }


</style>